import React from "react";
import { BiFileBlank } from "react-icons/bi";

const FormsList = ({ background, textColor }) => {
  const formsLIst = [
    { name: "ID Copy.pdf", size: "200 KB" },
    { name: "Drivers license 2022.pdf", size: "100 KB" },
    { name: "Credit Card Application.pdf", size: "150 KB" },
    { name: "Spouse Registration Document.pdf", size: "10.10 KB" },
  ];
  return (
    <div className={`rounded-lg border border-gray-200 px-4 pt-4 pb-6 my-4 shadow-sm ${background === 'bg-white' ? 'bg-white' : ''}`}>
      <div className="mb-4">
        <p className={`text-base font-semibold ${textColor}`}>Incident Reporting Forms</p>
        <p className={`text-sm ${textColor} opacity-75`}>
          All documents uploaded since December 2020
        </p>
      </div>
      <div className="space-y-3">
        {formsLIst.flatMap((item) => (
          <div className="bg-white rounded-lg flex justify-between items-center py-3 px-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center space-x-3 flex-1 min-w-0">
              <div className="flex-shrink-0 rounded-lg bg-purple-50 h-10 w-10 flex items-center justify-center">
                <BiFileBlank className="h-5 w-5 text-purple-600" />
              </div>
              <div className="min-w-0 flex-1">
                <span className="text-sm font-medium text-gray-900 block truncate">{item.name}</span>
                <p className="text-xs text-gray-500 mt-0.5">{item.size}</p>
              </div>
            </div>
            <div className="flex items-center space-x-2 ml-4 flex-shrink-0">
              <button className="rounded-md px-3 py-1.5 text-xs font-medium border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors">
                Edit
              </button>
              <button className="rounded-md px-3 py-1.5 text-xs font-medium bg-gradient text-white hover:opacity-90 transition-opacity">
                View
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormsList;
